// extracted by mini-css-extract-plugin
export default {"fs":"_29086d79ae _6fc39fa913"};